import { render } from "@/components/pages/individualWorkSupport/requirement008/Requirement008.html?vue&type=template&id=68ab193a&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement008/Requirement008.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement008/Requirement008.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement008/Requirement008.scss?vue&type=style&index=0&id=68ab193a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ab193a"]])

export default __exports__